import { ROLES } from "../../base/constant";

export const checkIfExist = (state: any, item: any) => {
  return state.users?.findIndex((user: any) => user.emailId === item);
};

export const checkIfSerachExist = (testTableData: any, item: any) => {
  return testTableData?.findIndex((user: any) => user.userid === item);
};

export const checkIfExiststring = (filterType: any, item: any) => {
  let index = filterType?.findIndex((type: any) => type === item);
  return index;
};

export const RemoveifExist = (state: any, index: any) => {
  return state?.filterType?.splice(index, 1);
};

export const checkIfTableRowExist = (state: any, item: any) => {
  return state.userTableData?.findIndex((user: any) => user.emailId === item);
};

export const getrole = (roleId: any) => {
  return roleId === parseInt(ROLES.AGENT_ROLE_ID)
    ? "Agent"
    : roleId === parseInt(ROLES.SUPERVISOR_ROLE_ID)
    ? "Supervisor"
    : roleId === parseInt(ROLES.OWNER_ROLE_ID)
    ? "Owner"
    : roleId === parseInt(ROLES.SUB_OWNER_ROLE_ID)
    ? "Subowner"
    : roleId === parseInt(ROLES.MEMBER_ROLE_ID)
    ? "Member"
    : "Admin";
};

export const getstatus = (statusvalue: any) => {
  return statusvalue === 0 ? "Inactive" : "Active";
};

export const addSkills = (data: any) => {
  let skills: any = typeof data?.addSkill === "string" ? JSON.parse(data?.addSkill.trim().length > 0 ? data?.addSkill : "null") ?? [] : data?.addSkill;
  let skillArray: any = skills?.length > 0 ? skills?.map((elem: any) => elem?.value) : [];
  return skillArray.length > 0 ? skillArray?.join() : "-";
};

export const getMappedObject = (state: any, data: any) => {
  state.availableUsers[`${data?.UserID}`] = 1;
  return {
    userid: data?.UserID,
    name: data?.UserName ? data?.UserName : "-",
    role: getrole(data?.roleid),
    routingprofileName: data?.routing_profile_name ? data?.routing_profile_name : "-",
    routingprofile: data?.routing_profile,
    reporttoname: data?.report_to_name ? data?.report_to_name : "-",
    addSkills: addSkills(data),
    reportingto: data?.report_to ? data?.report_to : "-",
    activeStatus: getstatus(data?.isActive),
    ext: data?.ext ? data?.ext : "-",
    emailId: data?.emailId,
    phoneNumber: data?.phone_number ? data?.phone_number : "-",
    deskNumber: data?.desk_phone_number ? data?.desk_phone_number : "-",
    inboundCall:data?.inboundCall,
    outboundCampaignCall:data?.outboundCampaignCall,
    is_outbound_campaign_specific_agent:data?.is_outbound_campaign_specific_agent,
    callTypeId:data?.callTypeId
  };
};

export const getMappedObjectForUpdate = (state: any, data: any, subIndex: any) => {
  let preveData: any = state.userTableData[subIndex];

  return {
    userid: preveData?.uid,
    name: preveData?.name ? preveData?.name : "-",
    role: preveData?.role,
    routingprofileName: data?.routing_profile_name ? data?.routing_profile_name : "-",
    routingprofile: data?.routing_profile,
    reporttoname: data?.report_to_name ? data?.report_to_name : "-",
    addSkills: data.add_skill, //addSkills(data),
    reportingto: data?.report_to ? data?.report_to : "-",
    activeStatus: preveData?.activeStatus,
    ext: preveData?.ext ? preveData?.ext : "-",
    emailId: preveData?.emailId,
    phoneNumber: preveData?.phone_number ? preveData?.phone_number : "-",
    deskNumber: preveData?.desk_phone_number ? preveData?.desk_phone_number : "-",
  };
};

export const resetFilter = (state: any) => {
  if (state.advancedSearchData.role.length !== 0 || state.advancedSearchData.routingProfileName.length !== 0 || state.advancedSearchData.reportToName.length !== 0) {
    state.userSearchData = state.userCopySearchData;
  } else {
    state.userSearchData = state.userTableData;
  }
};

export const filterData = (object: any, text: any) => {
  const name = object?.name?.toLowerCase() ?? "";
  const input = text?.toLowerCase();
  if (name.includes(input)) return true;
  else return false;
};

export const filterSearch = (object: any, text: any) => {
  const name = object?.name?.toLowerCase() ?? "";
  const reporttoname = object?.reporttoname?.toLowerCase() ?? "";
  const routingprofileName = object?.routingprofileName?.toLowerCase() ?? "";
  const role = object?.role?.toLowerCase() ?? "";
  const input = text?.toLowerCase();
  if (name.includes(input) || role.includes(input) || reporttoname.includes(input) || routingprofileName.includes(input)) return true;
  else return false;
};

export const filter = (WholeUser: Array<any>, filterType: string) => {
  return WholeUser.map((Users: any) => {
    filterSearchData(Users, filterType);
  });
};

export const filterSearchData = (object: any, text: any) => {
  const reporttoname = object?.reporttoname?.toLowerCase() ?? "";
  const routingprofileName = object?.routingprofileName?.toLowerCase() ?? "";
  const role = object?.role?.toLowerCase() ?? "";
  const input = text?.toLowerCase();
  if (role.includes(input) || reporttoname.includes(input) || routingprofileName.includes(input)) {
    return object;
  }
};

export const getReportTo = (WholeArray: any) => {
  let userReporter = [] as any;
  WholeArray.map((user: any) => {
    if ([3,5].includes(user?.roleid)) {
      userReporter.push(user?.UserName);
    }
  });
  return userReporter.filter((item: any, index: any) => userReporter.indexOf(item) === index);
};

export const getRoutingProfile = (wholeArray: any) => {
  let userRoutingProfile = [] as any;
  wholeArray.map((user: any) => {
    if (user.routing_profile_name) {
      userRoutingProfile.push(user.routing_profile_name);
    }
  });

  return userRoutingProfile.filter((item: any, index: any) => userRoutingProfile.indexOf(item) === index);
};

export const mapResponseDataToTable = (state: any, data: any) => {
  const userList: any = [];
  for (const datum of data) {
    userList.push(getMappedObject(state, datum));
  }
  state.userTableData = userList;
  state.userSearchData = userList;
  state.userCopySearchData = userList;
};

export const dataSearch = (state: any) => {
  const copyOfSearch = state.userTableData;

  state.testTableData.length = 0;

  copyOfSearch.filter((users: any) => {
    if (state.advancedSearchData.role.length !== 0 && state.advancedSearchData.routingProfileName.length !== 0 && state.advancedSearchData.reportToName.length !== 0) {
      if (
        state.advancedSearchData.role.includes(users.role) &&
        state.advancedSearchData.routingProfileName.includes(users.routingprofileName) &&
        state.advancedSearchData.reportToName.includes(users.reporttoname)
      ) {
        let index = checkIfSerachExist(state.testTableData, users.userid);
        if (index === -1) {
          state.testTableData.push(users);
        }
      }
    } else if (
      state.advancedSearchData.role.length === 0 &&
      state.advancedSearchData.routingProfileName.length === 0 &&
      state.advancedSearchData.reportToName.length === 0
    ) {
      state.testTableData = state.userTableData;
    } else {
      if (state.advancedSearchData.role.length !== 0 && state.advancedSearchData.routingProfileName.length !== 0 && state.advancedSearchData.reportToName.length === 0) {
        if (state.advancedSearchData.role.includes(users.role) && state.advancedSearchData.routingProfileName.includes(users.routingprofileName)) {
          let index = checkIfSerachExist(state.testTableData, users.userid);
          if (index === -1) {
            state.testTableData.push(users);
          }
        }
      } else if (
        state.advancedSearchData.role.length !== 0 &&
        state.advancedSearchData.routingProfileName.length === 0 &&
        state.advancedSearchData.reportToName.length !== 0
      ) {
        if (state.advancedSearchData.role.includes(users.role) && state.advancedSearchData.reportToName.includes(users.reporttoname)) {
          let index = checkIfSerachExist(state.testTableData, users.userid);
          if (index === -1) {
            state.testTableData.push(users);
          }
        }
      } else if (
        state.advancedSearchData.role.length === 0 &&
        state.advancedSearchData.routingProfileName.length !== 0 &&
        state.advancedSearchData.reportToName.length !== 0
      ) {
        if (state.advancedSearchData.routingProfileName.includes(users.routingprofileName) && state.advancedSearchData.reportToName.includes(users.reporttoname)) {
          let index = checkIfSerachExist(state.testTableData, users.userid);
          if (index === -1) {
            state.testTableData.push(users);
          }
        }
      } else {
        if (state.advancedSearchData.role.includes(users.role)) {
          let index = checkIfSerachExist(state.testTableData, users.userid);
          if (index === -1) {
            state.testTableData.push(users);
          }
        }

        if (state.advancedSearchData.routingProfileName.includes(users.routingprofileName)) {
          let index = checkIfSerachExist(state.testTableData, users.userid);
          if (index === -1) {
            state.testTableData.push(users);
          }
        }

        if (state.advancedSearchData.reportToName.includes(users.reporttoname)) {
          let index = checkIfSerachExist(state.testTableData, users.userid);
          if (index === -1) {
            state.testTableData.push(users);
          }
        }
      }
    }
  });

  state.userSearchData = state.testTableData;

  state.userCopySearchData = state.testTableData;
};
